import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // <-- IMPORT DO PRZEKIEROWAŃ
import { Button } from '../components/common/Button';
import { Input } from '../components/common/Input';
import { authService } from '../services/authService';

// Style pozostają bez zmian
const containerStyle: React.CSSProperties = { /*...*/ };
const formStyle: React.CSSProperties = { /*...*/ };

export const LoginPage = () => {
  const [loginInput, setLoginInput] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoginLoading, setIsLoginLoading] = useState(false);
  
  // ZMIANA: Pobieramy właściwą zmienną z kontekstu
  const navigate = useNavigate();

const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError('');
    setIsLoginLoading(true);

    try {
     const user = await authService.login(loginInput, password);
      
      // LOGIKA PRZEKIEROWANIA
      if (user.role === 'instruktor') {
            navigate('/instruktor');
        } else {
            navigate('/kursant');
        }
    } catch (err: any) {
        setError(err.message || 'Wystąpił nieznany błąd');
    } finally {
        setIsLoginLoading(false);
    }
};

  return (
    <div style={containerStyle}>
      <form style={formStyle} onSubmit={handleSubmit}>
        <h1 style={{ textAlign: 'center', marginBottom: '2rem' }}>Logowanie</h1>
        
        <Input
          id="login"
          label="Login"
          type="text"
          value={loginInput}
          onChange={(e) => setLoginInput(e.target.value)}
          required
          disabled={isLoginLoading} // ZMIANA
        />

        <Input
          id="password"
          label="Hasło"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={isLoginLoading} // ZMIANA
        />
        
        {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}

        <Button type="submit" style={{ width: '100%' }} disabled={isLoginLoading}>
          {isLoginLoading ? 'Logowanie...' : 'Zaloguj się'} {/* ZMIANA */}
        </Button>
      </form>
    </div>
  );
};